import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';

interface UseToggleContactDocumentProps {
  contactId?: string
  publicCompanyLeadId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useToggleContactDocument = ({
  contactId,
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseToggleContactDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['toggleContactDocument'],
    mutationFn: async ({ value, type, documentId }: { value: boolean; type: string; documentId?: string }) => {
      const lead = {
        contacts_attributes: [
          {
            id: contactId,
            documents_attributes: [value ? { type } : { id: documentId, _destroy: true }],
          },
        ],
      }

      return privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      });
    },
    onSuccess,
    onError,
  })
}
